import { Route } from 'react-router-dom';
import { RequireAdminEsign } from '../../../common/SharedComponents';

import AdminSignAgreement from '../../../user/AdminSignAgreement';

export default function UserAgreementRoutes() {
    return (
        <>
            <Route
                path='/admin/signagreement'
                element={
                    <RequireAdminEsign>
                        <AdminSignAgreement />
                    </RequireAdminEsign>
                }
            />
        </>
    );
}
